<div class="animate-pulse">
    <div class="overflow-x-auto" [ngClass]="contentWidth">
      <table class="w-full text-sm">
        <tbody>
          @for (row of [1, 2, 3]; track row) {
            <tr>
              <td class="py-4">
                <div class="h-6 bg-gray-100 rounded"></div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
  